export default __webpack_public_path__ + "static/media/maintenance.0c72d37a.png";